import React, { useCallback, useEffect, useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import MenuItem from '../components/MenuItem';
// import StoryComponent from '../components/StoryComponent';
import '../App.css';
import Auth from '../core/services/auth';
// import { stories, } from '../core/lib/data';
// import StoryComponent from '../components/StoryComponent';
// import { StoryType } from "../core/lib/types";
// import Avatar from 'react-avatar';
import { Post, DataResponsetype } from '../core/lib/types';
import PostComponent from '../components/PostComponent';
// import ProfilePostComponent from '../components/ProfilePostComponent';
import { splitArrayIntoGroups } from '../core/lib/utils';
import InfiniteScroll from 'react-infinite-scroll-component';
import { ToastContainer, toast } from 'react-toastify';
import _ from 'lodash';
import MainStoryComponent from '../components/MainStoryComponent';

function Home() {
    // navigate to Login
    const navigate = useNavigate();
    const [ type, setType ] = useState("")
    const [ params, setParams ] = useState({
        page: !_.isEmpty(Auth.getPostCache()) ? Auth.getPostCache().page: 1 , limit: 6, sort: "-createdAt",
    })
    const [ params2, setParams2 ] = useState({
      page: 1 , limit: 6, sort: "-createdAt",
    })
    const [ post, setPost ] = useState<DataResponsetype>({ total: 0, pages: 0, page: 0, limit: 0, data: [] })
    const [ story, setStory ] = useState<any>({ total: 0, totalPages: 0, page: 0, storiesByVendor: [] })

    const getData = useCallback(() => {
      //
      // setType(args)
      if (type === "posts") {
        //
        setParams2({ page: 1 , limit: 6, sort: "-createdAt" })
        // Auth.api.get("/posts", { params: params} ).then(res=>{
        //     setPost(res.data.data)
        // })

      } else if (type === "pins") {
          //
          // Auth.api.get("/pins", { params: params}).then(res=>{
          //     setPost(res.data.data)
          // })
      } else {
          //

          Auth.api.get("/posts", { params: params} ).then(res=>{

            // check for cache
              if (Auth.checkPostCached(res.data.data.data)) {

                setPost(Auth.getPostCache())
                //

              } else {
                setPost(res.data.data)
                //
                Auth.setPostCache(res.data.data)
              }
              
          }).catch(err=> {
            //
            // logout()
          })

          // const logout = ()=> {
          //   Auth.logout().then(()=>{
          //     //
          //     navigate('/login')
          //   })
          // };

          Auth.api.get("/stories/stories-by-vendor", { params: params2} ).then(res=>{

            // check for cache
            setStory(res.data)
              
          })

          if (params.page > 1) {

            Auth.api.get("/posts", { params: { page: 1 , limit: 6, sort: "-createdAt" } } ).then(res=>{
              
              if (Auth.checkPostCached(res.data.data.data)) {

                setPost(res.data.data)
                
                Auth.setPostCache(res.data.data)

                setParams({ page: res.data.data.page , limit: 6, sort: "-createdAt" })

              } else {
                setPost(res.data.data)
                
                Auth.setPostCache(res.data.data)

                setParams({ page: res.data.data.page , limit: 6, sort: "-createdAt" })
              }
            })
          }
          
      }

    }, [params, params2, type])
    console.log(Auth.getUser() === '{}')
    // use effect
    useEffect(() => {
      
      if (!Auth.isAuthenticated() && Auth.getUser() === '{}') {
        navigate('/splashscreen')
        return;
      }
      
      // chec
      // Auth.api.get("/posts", { params: params} ).then(res=>{
      //     setPost(res.data.data)

      //     console.log(res.data.data)
      //   })
      // params.page = 1
      setType('')

      if (Object.keys(Auth.getPostCache()).length > 0) {
        setPost(Auth.getPostCache())
      }
      
      getData()
      // setParams({
      //     page: 1, limit: 6, sort: "-createdAt",
      // })

      
      
    }, [setType, getData, navigate])
    // 
    const _story =  story.storiesByVendor.length > 0 ? story.storiesByVendor : []

    const storyItems = _story.map(
      // _story => <StoryComponent story={_story} />
      // _story => <li> {_story.caption} </li>
      (_mstory: any) => 
        <MainStoryComponent stories={_mstory.stories} vendor={_mstory.vendor} allStories={story.storiesByVendor}/>
        
    )

    // const _posts = post.data.length > 0 ? post.data : posts
    const _posts = post.data.length > 0 ? post.data : []

    // console.log(splitArrayIntoGroups(posts, 3))
    //
    const _dataSplit3 = splitArrayIntoGroups(_posts, 4)

    const postList = _posts.filter((d,i) => i % 4 === 0).map(
      (_post: any, index: number ) => 
       
        <div className="grid gap-3" key={_post.id}>
            
            {
            _dataSplit3[index].map(
              (post_: Post) => 
                <PostComponent 
                        key={post_.id}
                            caption={post_.caption} 
                            media={post_.media} 
                            user={post_.user} 
                            profile={post_.profile} 
                            location={post_.location} 
                            id={post_.id} 
                            vendor={post_.vendor}
                            createdAt={post_.createdAt}
                            meta={post_.meta}
                            user_action={post_.user_action}
                            posts={_posts}
                            likedBy={post_.likedBy}
                            likes={post_.likes}
                            pinnedBy={post_.pinnedBy}
                            params={params}
                            setParams={setParams}
                            total={post.total}
                          />
            ) 
          }
        </div>
          
        
    )

    const onSet = (ars: string) => {
      //
      setParams({
          page: 1, limit: 6, sort: "-createdAt",
      })
      setType(ars)
    }

    const fetchData = () => {
      //
      if (post.data.length >= post.total) {
          // setMore(false)
          return;
      }
      params.page++

      // console.log(params)

      Auth.api.get("/posts", { params: params} ).then(res=> {
          //

          // setPost(res.data.data)

          // const data = { total: res.data.data.total, pages: res.data.data.pages, page: _page, limit: _limit, data: [...post.data, ...res.data.data.data] }


          if (Auth.checkPostCached(res.data.data.data)) {

            // setPost({
            //   total: post.total, 
            //   pages: post.pages, 
            //   page: post.page, 
            //   limit: post.limit,
            //   data: post.data.concat(res.data.data.data)
            // })

            // setPost(Auth.getPostCache)

          } else {

            setPost({
              total: post.total, 
              pages: post.pages, 
              page: post.page, 
              limit: post.limit,
              data: post.data.concat(res.data.data.data)
            })
            //

            // console.log('not cached')

            // let data = Auth.getPostCache().data
            // console.log(data)

            // Auth.setPostCache({
            //   total: res.data.data.total, 
            //   page: res.data.data.page, 
            //   pages: res.data.data.pages, 
            //   limit: res.data.data.limit,
            //   data: data.concat(res.data.data.data)
            // })
          }

          // setPost({
          //   total: post.total, 
          //   pages: post.pages, 
          //   page: post.page, 
          //   limit: post.limit,
          //   data: post.data.concat(res.data.data.data)
          // })

          // console.log(post.data)
            
          // console.log(params)
        })
        .catch(err=>{
    
          console.log(err)
          
          toast.error(err.response.data.error ? err.response.data.error.message : err.message, {
            position: "top-center",
          });
  
      })
  
    }

    const fetchData2 = () => {
      //
      if (story.totalPages.length >= story.total) {
          // setMore(false)
          return;
      }

      params2.page++

      // console.log(params2)

      Auth.api.get("/stories/stories-by-vendor", { params: params2 } ).then(res=> {

            setStory({
              total: story.total, 
              pages: story.pages, 
              totalPages: story.totalPages,
              storiesByVendor: story.storiesByVendor.concat(res.data.storiesByVendor)
            })
            //

        })
        .catch(err=>{
    
          console.log(err)
          
          toast.error(err.response.data.error ? err.response.data.error.message : err.message, {
            position: "top-center",
          });
  
      })
  
    }
      
    return (
        <section className='dark:text-white'>
          <ToastContainer />
            <div className=' bg-gray-100  py-4 dark:bg-gray-700'>
              <InfiniteScroll
                  dataLength={story.storiesByVendor.length}
                  hasMore={true}
                  next={fetchData2}
                  loader={<p className='text-center'></p>}
                  >
                <ul className='flex flex-row space-x-4 overflow-x-scroll pl-7 pr-5 '>
                  {storyItems}
                </ul>
              </InfiniteScroll>
            </div>
            <div className='relative w-full h-10'>
              <div className='py-4 px-5 absolute start-0 flex'>
                <p className='text-sm font-medium'> Discover</p>
              </div>
              <div className='py-3 px-5 absolute end-0 flex'>
                <NavLink to="/event" className=""> 
                  <button type="button" className="flex flex-row items-center justify-items-center py-1.5 px-5 bg-gray-100 mb-2 text-xs font-medium text-yellow focus:outline-none rounded-full dark:focus:ring-gray-700 dark:bg-black dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">  
                  <span className='pr-0.5'>Events</span> 
                  <svg className="text-yellow w-3 h-3 pt-0.5" fill="currentColor" aria-hidden="true" viewBox="0 0 24 24" data-testid="ArrowForwardIosIcon"><path d="M6.23 20.23 8 22l10-10L8 2 6.23 3.77 14.46 12z"></path></svg>
                  
                  </button>
                  
                </NavLink>
              </div>
            </div>
            {/* <button onClick={e=>Auth.logout()} className='p-3'>Logout</button> */}
            <div className="md:h-screen mx-auto p-3 mb-20 dark:bg-gray-800">
              <InfiniteScroll
                dataLength={post.data.length}
                hasMore={true}
                next={fetchData}
                loader={<p className='text-center'></p>}
                >
                  <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                  { postList }              
                </div>
            </InfiniteScroll>
            <button className='invisible' onClick={e=>onSet('')}></button>
            </div>
            <MenuItem />
        </section>
    );
  }
  
  export default Home;
  

